import { ResponseHelper } from '../_helpers/response.helper'
import axiosInstance from './axios.service'
import {
  C100HistorySummary,
  C100HistoryVersion,
  C100Payload,
  C100TickerTimeline,
  C100Timeframe
} from '../_types/carnivore100.type'

type Failure = { errMsg: string }

export class Carnivore100Service {
  private setError: (message: string | null) => void

  constructor(setError: (message: string | null) => void) {
    this.setError = setError
  }

  async getTable(timeframe: C100Timeframe): Promise<C100Payload | Failure> {
    return this.get<C100Payload>('/carnivore-100', { timeframe })
  }

  async getHistory(): Promise<C100HistorySummary[] | Failure> {
    return this.get<C100HistorySummary[]>('/carnivore-100/history')
  }

  async getHistoryVersion(version: number): Promise<C100HistoryVersion | Failure> {
    return this.get<C100HistoryVersion>(`/carnivore-100/history/${version}`)
  }

  async getTickerHistory(ticker: string): Promise<C100TickerTimeline | Failure> {
    return this.get<C100TickerTimeline>(
      `/carnivore-100/history/ticker/${encodeURIComponent(ticker)}`
    )
  }

  private async get<T>(url: string, params?: Record<string, string>): Promise<T | Failure> {
    // hard timeout so a stuck backend surfaces as a retryable error,
    // never an infinite loading state
    return axiosInstance
      .get(url, { params, timeout: 30000 })
      .then(res => res.data.data as T)
      .catch(async e => {
        const result = await ResponseHelper.handleError(e, this.setError)
        return result || { errMsg: 'an error occurred' }
      })
  }
}
